import { useQuery } from "@tanstack/react-query";
import {
  AccessRequestsResponse,
  fetchAccessRequests
} from "PFCore/services/admin/access_requests/fetch_access_requests";
import { QueryParams } from "PFTypes/query_params";
import { QueryOptions } from "PFTypes/request_options";

import { accessRequestsKeys } from "./query_keys";

export const useAccessRequests = (
  params: Pick<QueryParams, "page" | "perPage">,
  options?: QueryOptions<AccessRequestsResponse>
) => {
  const queryKey = accessRequestsKeys.list(params);

  return useQuery(queryKey, () => fetchAccessRequests(params), options);
};
